import React from "react";
import { TextField } from "@mui/material";

const CustomNumber2 = ({ value, onChange, name, label, maxLength, disabled }) => {
    
    const handleChange = (event) => {
        const inputValue = event.target.value;


        const numericValue = inputValue.replace(/\D/g, ""); 
        const limitedValue = maxLength ? numericValue.slice(0, maxLength) : numericValue;

        onChange(limitedValue); 
    };

    return (
        <TextField
            name={name}
            label={label}
            value={value || ""} 
            onChange={handleChange}
            disabled={disabled}
            fullWidth
            type="text" 
            inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }} 
            sx={{
                width: "100%",
                textAlign: "left",
                borderRadius: "10px",
                backgroundColor: "#FFFFFF", 
                "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                        borderColor: "#fda03d",
                    },
                    "&:hover fieldset": {
                    borderColor: "#fda03d", 
                    },
                    "&.Mui-focused fieldset": {
                    borderColor: "#fda03d", 
                    },
                },
                "& .MuiOutlinedInput-root.Mui-disabled": {
                    bgcolor: "transparent",
                    cursor: "not-allowed",
                },
                "& .Mui-disabled": {
                    cursor: "not-allowed",
                },
                "& .MuiInputLabel-root.Mui-focused": {
                    color: "#fda03d", 
                },
                }}
        />
    );
};

export default CustomNumber2;
